export class LogBookErrorFilter {
    searchTerm: string;

    constructor(searchTerm: string = '') {
        this.searchTerm = searchTerm;
    }
}